<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="shareDocsModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Compartilhar receita, requisição de exames e atestado com o paciente</h5>
                        <button type="button" class="close" @click="fechar()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!atendimento && $store.state.loading" />
                        <div class="d-flex flex-column" v-if="atendimento && atendimento.paciente && atendimento.paciente.cadastro">
                            <div class="mb-2">
                                <label class="form form-control">
                                    <i class="far fa-envelope mr-2" aria-hidden="true"></i>
                                    {{ ( atendimento && atendimento.paciente.cadastro.st_email ) ? atendimento.paciente.cadastro.st_email : 'Não disponível' }}
                                </label>
                                <label class="form form-control">
                                    <i class="fa fa-mobile mr-2" aria-hidden="true"></i>
                                    {{ ( atendimento && atendimento.paciente.cadastro.telefones.celular ) ? 
                                        $util.formatMask(atendimento.paciente.cadastro.telefones.celular, 'cel') : 'Não disponível' }}
                                </label>
                            </div>

                            <button type="button" class="btn btn-outline-primary" @click="enviar_para_paciente()"
                                v-if="atendimento && atendimento.paciente.cadastro.st_email">
                                <i class="far fa-envelope mr-2"></i>
                                Enviar por e-mail
                            </button>
                            <a class="btn btn-outline-info mt-2" href="#" @click.prevent="enviar_para_paciente_telegram()" target="_blank" 
                                v-if="atendimento && atendimento.paciente.cadastro.st_telegram_chat_id">
                                <i class="fab fa-telegram-plane mr-2"></i>
                                Enviar pelo Telegram
                            </a>
                            <a class="btn btn-outline-success mt-2" :href="enviar_para_whatsapp()" target="_blank" 
                                v-if="atendimento && atendimento.paciente.cadastro.telefones.celular">
                                <i class="fa fa-whatsapp mr-2" aria-hidden="true"></i> Enviar pelo WhatsApp
                            </a>
                        </div>

                        <div v-if="atendimento">
                            <div class="input-group mt-3">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <input type="checkbox" v-model="enviar_copia_oculta">
                                    </div>
                                </div>
                                <label class="form-control">Enviar e-mail com cópia oculta pra mim</label>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar()">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzEmptyState from '../../util/AzEmptyState.vue';

export default {
    data() { 
        return { 
            atendimento: null, 
            documentos_certificados: null, 
            enviar_copia_oculta: false, 
        }
    },

    components: { 
        AzEmptyState,
    },

    methods: { 
        fechar() { 
            $('#shareDocsModal').modal('hide');
        },
        compartilhar(id) { 
            this.atendimento = null;
            $('#shareDocsModal').modal('show');
            this.$store.commit('loading', true);

            this.$util.loadItem(this, { 
                service: 'pep',
                func: 'show',
                parms: { 
                    id: id,
                }
            })
            .then(res => { 
                this.atendimento = res.atendimento;
            })
            .finally(() => { 
                this.$store.commit('loading', false);
            });
        },

        enviar_para_paciente() {
    
            this.$util.atualizar(this, { 
                service: 'pep',
                func: 'enviar_para_paciente',
                dados: { 
                    id_atendimento: this.atendimento.id_atendimento,
                    copia_oculta: this.enviar_copia_oculta,
                },
                modal: "shareDocsModal",
                callback: () => { 
                    this.$toast.add({
                        severity: "success",
                        summary: "Atualizar",
                        detail: "Documentos enviados para o paciente.",
                        life: 3000
                    });
                }
            });

        },

        enviar_para_paciente_telegram() { 

            this.$util.atualizar(this, { 
                service: 'pep',
                func: 'enviar_para_paciente',
                dados: { 
                    id_atendimento: this.atendimento.id_atendimento,
                    telegram: true,
                },
                modal: "sharePrescrModal",
                callback: () => { 
                    this.$toast.add({
                        severity: "success",
                        summary: "Atualizar",
                        detail: "Documentos enviados para o paciente.",
                        life: 3000
                    });
                }
            });

        },

        enviar_para_whatsapp() { 

            let nl = "%0D%0A";
            let msg = "Prezado(a) ";
            let celular = "";

            if ( !this.documentos_certificados )
                return "abc";

            let texto = this.documentos_certificados.reduce((total, item) => { 
                return total = total + item.doc_certificado_link + nl;
                }, "");

            msg = msg + this.atendimento.paciente.st_nome;
            celular = this.atendimento.paciente.cadastro.telefones.celular;
            
            if (!celular) {
                return "javascript:alert('Celular não disponível')";
            }

            celular = "55" + celular;

            msg = msg + nl;
            msg = msg + "Links para os documentos gerados no atendimento:" + nl;
            msg = msg + texto;

            return "https://wa.me/" + celular + "?text=" + msg;

        },
    }
}
</script>